var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCheccked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4H19C19.5477 4 20 4.45228 20 5V19C20 19.5477 19.5477 20 19 20H5C4.45228 20 4 19.5477 4 19V5C4 4.45228 4.45228 4 5 4Z",
    stroke: "#202021",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4353 9.01879L16.158 7.73242L10.1882 13.7023L7.85095 11.3741L6.56458 12.6514L10.1882 16.266L17.4353 9.01879Z",
    fill: "#202021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheccked);
export default __webpack_public_path__ + "static/media/checkbox_checcked.7a1b01cbda0c6006040fe29c1c4e6c61.svg";
export { ForwardRef as ReactComponent };